var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.defaultPhoneNumber,
                  "phone-number-override": "",
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visible
        ? _c(
            "div",
            {
              staticClass: "external-widget-overlay",
              class: { "full-screen": _vm.fullScreen },
            },
            [
              _c("div", { staticClass: "external-widget-container" }, [
                _c(
                  "div",
                  { staticClass: "external-widget-header" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.title))]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "close-button",
                        attrs: { type: "link" },
                        on: { click: _vm.handleClose },
                      },
                      [_c("a-icon", { attrs: { type: "close" } })],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "external-widget-content" }, [
                  _c("iframe", {
                    staticClass: "widget-frame",
                    attrs: {
                      src: _vm.mode === "url" ? _vm.url : undefined,
                      srcdoc: _vm.mode === "html" ? _vm.html : undefined,
                      frameborder: "0",
                      allow:
                        "camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid; speaker-selection; encrypted-media; midi; sync-xhr",
                      sandbox:
                        "allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation",
                      "data-webtab-id": _vm.webTabId,
                      "data-keep-alive": _vm.keepAlive,
                    },
                  }),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }